var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.142,
    height: 17.142,
    viewBox: "0 0 17.142 17.142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message",
    transform: "translate(-0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1703",
    "data-name": "Path 1703",
    d: "M162.086,182H152.008a1.006,1.006,0,0,0-1,1v7.031a1.006,1.006,0,0,0,1,1h8.332l1.9,1.865a.5.5,0,0,0,.854-.358V183A1.006,1.006,0,0,0,162.086,182Zm-1.54,7h-7.031a.5.5,0,1,1,0-1h7.031a.5.5,0,0,1,0,1Zm-7.533-2.511a.5.5,0,0,1,.5-.5h5.022a.5.5,0,0,1,0,1h-5.022A.5.5,0,0,1,153.013,186.486Zm7.533-1.507h-7.031a.5.5,0,1,1,0-1h7.031a.5.5,0,1,1,0,1Z",
    transform: "translate(-145.945 -175.907)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1704",
    "data-name": "Path 1704",
    d: "M12.09,5.089V1a1.006,1.006,0,0,0-1-1H1.008A1.006,1.006,0,0,0,0,1v9.542a.5.5,0,0,0,.854.358l1.9-1.864h1.3V7.1A2.011,2.011,0,0,1,6.064,5.089ZM9.579,5.055a.5.5,0,1,1,.5-.5A.5.5,0,0,1,9.579,5.055ZM2.548,2.042H9.579a.5.5,0,0,1,0,1H2.548a.5.5,0,1,1,0-1Zm1,5.022h-1a.5.5,0,0,1,0-1h1a.5.5,0,0,1,0,1Zm-1-2.009a.5.5,0,1,1,0-1H7.57a.5.5,0,0,1,0,1Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.bea7962203aaa35af4a2b25de5a9b95a.svg";
export { ForwardRef as ReactComponent };